import { FC } from 'react';
import ProInput, { NewInputProps } from './input';
import ProInputGroup, { GroupProps } from './group';
import ProInputSearch, { SearchProps } from './search';
import ProInputTextArea, { NewTextAreaProps } from './textArea';
import ProInputPassword, { PasswordProps } from './password';

export type IInputComponent = FC<
  NewInputProps & React.RefAttributes<HTMLElement>
> & {
  Group: FC<GroupProps>;
  Search: FC<SearchProps & React.RefAttributes<HTMLElement>>;
  TextArea: FC<NewTextAreaProps & React.RefAttributes<HTMLElement>>;
  Password: FC<PasswordProps & React.RefAttributes<HTMLElement>>;
};

const TransInput = ProInput as IInputComponent;
TransInput.Group = ProInputGroup;
TransInput.Search = ProInputSearch;
TransInput.TextArea = ProInputTextArea;
TransInput.Password = ProInputPassword;

export default TransInput;
